import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles/index';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: unit * 2,
    },
});

function ScanFace(props) {
    return (
        <div>
            <Typography>
                Scan your id
            </Typography>
            <Typography>
                Please choose one of your identification documents
                (parsport or drivers license) and hold it up to your webcam
                so we can take picture of it.
            </Typography>
            <Button
                className={props.classes.button}
                onClick={() => {
                    props.setApplicantScannedId(true);
                    // TODO: set applicant data from youmio api
                }}
            >
                scan id
            </Button>
        </div>
    );
}

ScanFace.propTypes = {
    setApplicantScannedId: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScanFace);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/components/ScanId.js